import * as React from 'react';
import * as styles from './TourComponent.css';
import { TLabel, trackAnchorsClick } from './analytics/trackAnchorsClick';

export interface IMedia {
  text: string;
  url: string;
  label: TLabel;
}

export interface ITourComponent {
  anchors: IMedia[];
  media: IMedia[];
  allPhotos: IMedia;
}

export const TourComponent = (props: ITourComponent) => {
  const { anchors, media, allPhotos } = props;

  return (
    <div className={styles['tour']}>
      <h2 className={styles['title']}>Экскурсия по квартире</h2>
      <div className={styles['links']}>
        <ul className={styles['anchors']}>
          {anchors.map(item => {
            return (
              <li>
                <a className={styles['link']} href={item.url} onClick={() => trackAnchorsClick(item.label)}>
                  {item.text}
                </a>
              </li>
            );
          })}
        </ul>
        <a className={styles['link']} href={allPhotos.url} onClick={() => trackAnchorsClick('RoomTour/MorePhoto')}>
          {allPhotos.text}
        </a>
      </div>
      <div className={styles['media']}>
        {media.map(img => (
          <div
            className={styles['image']}
            style={{
              backgroundImage: `url(${img.url})`,
            }}
          >
            <img src={img.url} alt="" />
          </div>
        ))}
      </div>
    </div>
  );
};
